// extracted by mini-css-extract-plugin
export default {"mCard":"tB-z","image":"uB-z","imageNoBackground":"vB-z","imageHasCategory":"wB-z","fullWidth":"xB-z"};